import { AppTooltip } from '@lmt/unicorn-shared/app/components/common/ui-kit/tooltip/AppTooltip';
import React, { useMemo } from 'react';
import clsx from 'clsx';
import HintIcon from '@lmt/unicorn-shared/app/icons/i.svg?react';

import styles from './ToggleButton.module.scss';
import { createId } from '@lmt/unicorn-shared/app/helpers/create-id';

type Props = {
  name?: string;
  title?: string;
  checked?: boolean;
  defaultChecked?: boolean;
  value?: string | number;
  className?: string;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  testId?: string;
  hint?: React.ReactNode;
};

export const ToggleButton = React.forwardRef<HTMLInputElement, Props>(
  function AppSwitcherControl(props, ref) {
    const id = useMemo(() => createId(), []);
    return (
      <div
        className={clsx(styles.container)}
        data-test-id={props.testId ?? `toggle-${props.name}`}
      >
        <label className={styles.switch}>
          <input
            type="checkbox"
            ref={ref}
            id={id}
            checked={props.checked}
            defaultChecked={props.defaultChecked}
            name={props.name}
            value={props.value}
            disabled={props.disabled}
            onClick={props.onClick}
            onChange={props.onChange}
          />
          <span className={clsx(styles.slider, styles.round)} />
        </label>
        <label
          className={clsx(styles.label, props.disabled ? styles.disabled : '')}
          htmlFor={id}
        >
          {props.title}
        </label>
        {props.hint ? (
          <AppTooltip title={props.hint}>
            <div onClick={(e) => e.preventDefault()} className={styles.hint}>
              <HintIcon />
            </div>
          </AppTooltip>
        ) : null}
      </div>
    );
  },
);
